// import React, { useEffect, useMemo, useRef, useState } from "react";
// import styles from "./UpdateProfile.module.css";
// import useApi from "../../../custom_hooks/useApi";
// import { TextField } from "@mui/material";
// import CustomSelector from "../../../components/custom/CustomSelector";
// import {
//   fetchReasonsApi,
//   getAiProfileDescriptionApi,
//   updateProfileApi,
// } from "../../../services/newServices";
// import { Button } from "reactstrap";
// import { toast } from "react-toastify";
// import CustomButton from "../../../components/custom/CustomButton";
// import { useSelector } from "react-redux";
// import { uploadImagesToS3 } from "../../../utills/utils";
// import CustomImageUpload from "../../../components/custom/CustomImageUpload";
// import { trackEvent } from "../../../analytics";
// import { useTranslation } from "react-i18next";
// import storageService from "../../../services/storageServices";

// export default function UpdateProfile({ profileData }) {
//   const [image, setImage] = useState(null);
//   const [fullName, setFullName] = useState("");
//   const [description, setDescription] = useState("");
//   const [selectedLanguages, setSelectedLanguages] = useState([]);
//   const [selectedPersonalityTraits, setSelectedPersonalityTraits] = useState(
//     []
//   );
//   const [selectedProfileInterests, setSelectedProfileInterests] = useState([]);
//   const [saveLoading, setSaveLoading] = useState(false);
//   const [imageLoading, setImageLoading] = useState(false);
//   const [generateDescriptionLoading, setGenerateDescriptionLoading] =
//     useState(false);

//   const maxLimit = 5;

//   const ln = storageService.get("lang") || "en";

//   const {
//     selectedHotel: { id: hotelId },
//   } = useSelector((state) => state?.hotels);

//   const [languages] = useApi({
//     api: fetchReasonsApi,
//     values: "languages",
//     defaultValue: [],
//     trackingName: "fetchReasonsApi",
//   });

//   const [personalityTraits] = useApi({
//     api: fetchReasonsApi,
//     values: `personality_traits&ln=${ln}`,
//     defaultValue: [],
//     trackingName: "fetchReasonsApi",
//   });

//   const [profileInterests] = useApi({
//     api: fetchReasonsApi,
//     values: `profile_interests&ln=${ln}`,
//     defaultValue: [],
//     trackingName: "fetchReasonsApi",
//   });

//   const handleLanguageSelect = (languageId) => {
//     setSelectedLanguages({
//       ...selectedLanguages,
//       [languageId]: !selectedLanguages[languageId],
//     });
//   };

//   const handlePersonalityTraitsSelect = (personalityTraitsId) => {
//     setSelectedPersonalityTraits({
//       ...selectedPersonalityTraits,
//       [personalityTraitsId]: !selectedPersonalityTraits[personalityTraitsId],
//     });
//   };

//   const handleProfileInterestsSelect = (profileInterestsId) => {
//     setSelectedProfileInterests({
//       ...selectedProfileInterests,
//       [profileInterestsId]: !selectedProfileInterests[profileInterestsId],
//     });
//   };

//   const selectedLanguagesCount = useMemo(
//     () => Object.values(selectedLanguages).filter((val) => val).length,
//     [selectedLanguages]
//   );

//   const selectedPersonalityTraitsCount = useMemo(
//     () => Object.values(selectedPersonalityTraits).filter((val) => val).length,
//     [selectedPersonalityTraits]
//   );

//   const selectedProfileInterestsCount = useMemo(
//     () => Object.values(selectedProfileInterests).filter((val) => val).length,
//     [selectedProfileInterests]
//   );

//   const handleSave = async () => {
//     trackEvent("updateProfile-save-button-clicked");
//     let imageUrl;
//     if (image && image !== profileData?.imageUrl) {
//       setImageLoading(true);
//       const { data: url } = await uploadImagesToS3([image]);
//       imageUrl = url[0];
//       setImageLoading(false);
//       trackEvent("updateProfile-image-uploaded", { imageUrl });
//     }
//     setSaveLoading(true);
//     updateProfileApi({
//       hotelId,
//       name: fullName,
//       languages: getSelectedValues(selectedLanguages),
//       personalityTraits: getSelectedValues(selectedPersonalityTraits),
//       profileInterests: getSelectedValues(selectedProfileInterests),
//       imageUrl: imageUrl || null,
//       description: description || null,
//     })
//       .then(() => {
//         toast.success(t("success"));
//         trackEvent("updateProfile-successfully-saved");
//       })
//       .catch(() => {
//         toast.error(t("please_try_again_later"));
//         trackEvent("updateProfile-saving-error");
//       })
//       .finally(() => {
//         setSaveLoading(false);
//       });
//   };

//   const getSelectedValues = (values) => {
//     const mappedValues = Object.entries(values)
//       .filter(([_, val]) => val)
//       .map(([id]) => id);
//     return mappedValues.length ? mappedValues : null;
//   };

//   const lang = storageService.get("lang") || "en";

//   const handleGenerateDescription = async () => {
//     try {
//       setGenerateDescriptionLoading(true);
//       const description = await getAiProfileDescriptionApi(hotelId, lang);
//       if (!description?.data) {
//         return toast.error(t("please_try_again_later"));
//       }
//       setDescription(description.data);
//     } catch {
//       toast.error(t("please_try_again_later"));
//     } finally {
//       setGenerateDescriptionLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (profileData) {
//       setFullName(profileData.name);
//       setDescription(profileData.description);
//       setImage(profileData.imageUrl);
//       setSelectedLanguages(
//         profileData.languages?.reduce((acc, curr) => {
//           acc[curr] = true;
//           return acc;
//         }, {}) ?? {}
//       );
//       setSelectedPersonalityTraits(
//         profileData.personalityTraits?.reduce((acc, curr) => {
//           acc[curr] = true;
//           return acc;
//         }, {}) ?? {}
//       );
//       setSelectedProfileInterests(
//         profileData.profileInterests?.reduce((acc, curr) => {
//           acc[curr] = true;
//           return acc;
//         }, {}) ?? {}
//       );
//     }
//   }, [profileData]);

//   useEffect(() => {
//     trackEvent("updateProfile-page-visited");
//   }, []);

//   const { t } = useTranslation();

//   return (
//     <div className={styles.container}>
//       <div className={styles.title}>{t("about_you")}</div>
//       <CustomImageUpload value={image} onChange={(img) => setImage(img)} />
//       <div className={styles.wrapper}>
//         <TextField
//           label={t("full_name")}
//           value={fullName}
//           onChange={(e) => setFullName(e.target.value)}
//           className={styles.input}
//         />
//       </div>
//       <div className={styles.wrapper}>
//         <div className={styles.text}>{t("description")}</div>
//         <textarea
//           value={description}
//           className={styles["text-area-description"]}
//           rows={6}
//           onChange={(e) => setDescription(e.target.value)}
//         ></textarea>
//         <CustomButton
//           loading={generateDescriptionLoading}
//           onClick={handleGenerateDescription}
//         >
//           {t("generate_description_ai")}
//         </CustomButton>
//       </div>
//       <div className={styles.wrapper}>
//         <div className={styles.text}>
//           {t("languages")}{" "}
//           <span className={styles["count"]}>
//             {selectedLanguagesCount}/{maxLimit}
//           </span>
//         </div>
//         <div className={styles["selectors"]}>
//           {languages.map((language) => {
//             return (
//               <CustomSelector
//                 isActive={!!selectedLanguages[language.id]}
//                 onSelect={() => handleLanguageSelect(language.id)}
//                 key={language.id}
//                 disable={
//                   selectedLanguagesCount === maxLimit &&
//                   !selectedLanguages[language.id]
//                 }
//               >
//                 {language.description}
//               </CustomSelector>
//             );
//           })}
//         </div>
//       </div>
//       <div className={styles.wrapper}>
//         <div className={styles.text}>
//           {t("nature")}{" "}
//           <span className={styles["count"]}>
//             {selectedPersonalityTraitsCount}/{maxLimit}
//           </span>
//         </div>
//         <div className={styles["selectors"]}>
//           {personalityTraits.map((personalityTraits) => {
//             return (
//               <CustomSelector
//                 isActive={!!selectedPersonalityTraits[personalityTraits.id]}
//                 onSelect={() =>
//                   handlePersonalityTraitsSelect(personalityTraits.id)
//                 }
//                 key={personalityTraits.id}
//                 disable={
//                   selectedPersonalityTraitsCount === maxLimit &&
//                   !selectedPersonalityTraits[personalityTraits.id]
//                 }
//               >
//                 {personalityTraits?.Transalations?.name ||
//                   personalityTraits.description}
//               </CustomSelector>
//             );
//           })}
//         </div>
//       </div>
//       <div className={styles.wrapper}>
//         <div className={styles.text}>
//           {t("interests")}{" "}
//           <span className={styles["count"]}>
//             {selectedProfileInterestsCount}/{maxLimit}
//           </span>
//         </div>
//         <div className={styles["selectors"]}>
//           {profileInterests.map((profileInterest) => {
//             return (
//               <CustomSelector
//                 isActive={!!selectedProfileInterests[profileInterest.id]}
//                 onSelect={() =>
//                   handleProfileInterestsSelect(profileInterest.id)
//                 }
//                 key={profileInterest.id}
//                 disable={
//                   selectedProfileInterestsCount === maxLimit &&
//                   !selectedProfileInterests[profileInterest.id]
//                 }
//               >
//                 {profileInterest?.Transalations?.name ||
//                   profileInterest.description}
//               </CustomSelector>
//             );
//           })}
//         </div>
//       </div>
//       <div className={styles.wrapper}>
//         <div className={styles["buttons-container"]}>
//           <CustomButton
//             onClick={handleSave}
//             loading={saveLoading || imageLoading}
//             color="primary"
//           >
//             {t("save")}
//           </CustomButton>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./UpdateProfile.module.css";
import useApi from "../../../custom_hooks/useApi";
import { TextField } from "@mui/material";
import CustomSelector from "../../../components/custom/CustomSelector";
import {
  fetchReasonsApi,
  getAiProfileDescriptionApi,
  updateProfileApi,
} from "../../../services/newServices";
import { Button } from "reactstrap";
import { toast } from "react-toastify";
import CustomButton from "../../../components/custom/CustomButton";
import { useSelector } from "react-redux";
import { uploadImagesToS3 } from "../../../utills/utils";
import CustomImageUpload from "../../../components/custom/CustomImageUpload";
import { trackEvent } from "../../../analytics";
import { useTranslation } from "react-i18next";
import storageService from "../../../services/storageServices";

export default function UpdateProfile({ profileData }) {
  const [image, setImage] = useState(null);
  const [fullName, setFullName] = useState("");
  const [description, setDescription] = useState("");
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [selectedPersonalityTraits, setSelectedPersonalityTraits] = useState(
    []
  );
  const [selectedProfileInterests, setSelectedProfileInterests] = useState([]);
  const [saveLoading, setSaveLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [generateDescriptionLoading, setGenerateDescriptionLoading] =
    useState(false);

  const maxLimit = 5;

  const ln = storageService.get("lang") || "en";

  const {
    selectedHotel: { id: hotelId },
  } = useSelector((state) => state?.hotels);

  const [languages] = useApi({
    api: fetchReasonsApi,
    values: "languages",
    defaultValue: [],
    trackingName: "fetchReasonsApi",
  });

  const [personalityTraits] = useApi({
    api: fetchReasonsApi,
    values: `personality_traits&ln=${ln}`,
    defaultValue: [],
    trackingName: "fetchReasonsApi",
  });

  const [profileInterests] = useApi({
    api: fetchReasonsApi,
    values: `profile_interests&ln=${ln}`,
    defaultValue: [],
    trackingName: "fetchReasonsApi",
  });

  const handleLanguageSelect = (languageId) => {
    setSelectedLanguages({
      ...selectedLanguages,
      [languageId]: !selectedLanguages[languageId],
    });
  };

  const handlePersonalityTraitsSelect = (personalityTraitsId) => {
    setSelectedPersonalityTraits({
      ...selectedPersonalityTraits,
      [personalityTraitsId]: !selectedPersonalityTraits[personalityTraitsId],
    });
  };

  const handleProfileInterestsSelect = (profileInterestsId) => {
    setSelectedProfileInterests({
      ...selectedProfileInterests,
      [profileInterestsId]: !selectedProfileInterests[profileInterestsId],
    });
  };

  const selectedLanguagesCount = useMemo(
    () => Object.values(selectedLanguages).filter((val) => val).length,
    [selectedLanguages]
  );

  const selectedPersonalityTraitsCount = useMemo(
    () => Object.values(selectedPersonalityTraits).filter((val) => val).length,
    [selectedPersonalityTraits]
  );

  const selectedProfileInterestsCount = useMemo(
    () => Object.values(selectedProfileInterests).filter((val) => val).length,
    [selectedProfileInterests]
  );

  const handleSave = async () => {
    trackEvent("updateProfile-save-button-clicked");
    if (!fullName || fullName.trim() === "") {
      toast.error(t("Name cannot be empty"));
      trackEvent("updateProfile-name-empty-error");
      return;
    }
    if (!description || description.trim() === "") {
      toast.error(t("Description can not be empty"));
      trackEvent("updateprofile-description-empty-error");
      return;
    }
    let imageUrl;
    if (image && image !== profileData?.imageUrl) {
      setImageLoading(true);
      const { data: url } = await uploadImagesToS3([image]);
      imageUrl = url[0];
      setImageLoading(false);
      trackEvent("updateProfile-image-uploaded", { imageUrl });
    }
    setSaveLoading(true);
    updateProfileApi({
      hotelId,
      name: fullName,
      languages: getSelectedValues(selectedLanguages),
      personalityTraits: getSelectedValues(selectedPersonalityTraits),
      profileInterests: getSelectedValues(selectedProfileInterests),
      imageUrl: imageUrl || null,
      description: description || null,
    })
      .then(() => {
        toast.success(t("success"));
        trackEvent("updateProfile-successfully-saved");
      })
      .catch(() => {
        toast.error(t("please_try_again_later"));
        trackEvent("updateProfile-saving-error");
      })
      .finally(() => {
        setSaveLoading(false);
      });
  };

  const getSelectedValues = (values) => {
    const mappedValues = Object.entries(values)
      .filter(([_, val]) => val)
      .map(([id]) => id);
    return mappedValues.length ? mappedValues : null;
  };

  const lang = storageService.get("lang") || "en";

  const handleGenerateDescription = async () => {
    try {
      setGenerateDescriptionLoading(true);
      const description = await getAiProfileDescriptionApi(hotelId, lang);
      if (!description?.data) {
        return toast.error(t("please_try_again_later"));
      }
      setDescription(description.data);
    } catch {
      toast.error(t("please_try_again_later"));
    } finally {
      setGenerateDescriptionLoading(false);
    }
  };

  useEffect(() => {
    if (profileData) {
      setFullName(profileData.name);
      setDescription(profileData.description);
      setImage(profileData.imageUrl);
      setSelectedLanguages(
        profileData.languages?.reduce((acc, curr) => {
          acc[curr] = true;
          return acc;
        }, {}) ?? {}
      );
      setSelectedPersonalityTraits(
        profileData.personalityTraits?.reduce((acc, curr) => {
          acc[curr] = true;
          return acc;
        }, {}) ?? {}
      );
      setSelectedProfileInterests(
        profileData.profileInterests?.reduce((acc, curr) => {
          acc[curr] = true;
          return acc;
        }, {}) ?? {}
      );
    }
  }, [profileData]);

  useEffect(() => {
    trackEvent("updateProfile-page-visited");
  }, []);

  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.title}>{t("about_you")}</div>
      <CustomImageUpload value={image} onChange={(img) => setImage(img)} />
      <div className={styles.wrapper}>
        <TextField
          label={t("full_name")}
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
          className={styles.input}
        />
      </div>
      <div className={styles.wrapper}>
        <div className={styles.text}>{t("description")}</div>
        <textarea
          value={description}
          className={styles["text-area-description"]}
          rows={6}
          onChange={(e) => setDescription(e.target.value)}
        ></textarea>
        <CustomButton
          loading={generateDescriptionLoading}
          onClick={handleGenerateDescription}
        >
          {t("generate_description_ai")}
        </CustomButton>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.text}>
          {t("languages")}{" "}
          <span className={styles["count"]}>
            {selectedLanguagesCount}/{maxLimit}
          </span>
        </div>
        <div className={styles["selectors"]}>
          {languages.map((language) => {
            return (
              <CustomSelector
                isActive={!!selectedLanguages[language.id]}
                onSelect={() => handleLanguageSelect(language.id)}
                key={language.id}
                disable={
                  selectedLanguagesCount === maxLimit &&
                  !selectedLanguages[language.id]
                }
              >
                {language.description}
              </CustomSelector>
            );
          })}
        </div>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.text}>
          {t("nature")}{" "}
          <span className={styles["count"]}>
            {selectedPersonalityTraitsCount}/{maxLimit}
          </span>
        </div>
        <div className={styles["selectors"]}>
          {personalityTraits.map((personalityTraits) => {
            return (
              <CustomSelector
                isActive={!!selectedPersonalityTraits[personalityTraits.id]}
                onSelect={() =>
                  handlePersonalityTraitsSelect(personalityTraits.id)
                }
                key={personalityTraits.id}
                disable={
                  selectedPersonalityTraitsCount === maxLimit &&
                  !selectedPersonalityTraits[personalityTraits.id]
                }
              >
                {personalityTraits?.Transalations?.name ||
                  personalityTraits.description}
              </CustomSelector>
            );
          })}
        </div>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.text}>
          {t("interests")}{" "}
          <span className={styles["count"]}>
            {selectedProfileInterestsCount}/{maxLimit}
          </span>
        </div>
        <div className={styles["selectors"]}>
          {profileInterests.map((profileInterest) => {
            return (
              <CustomSelector
                isActive={!!selectedProfileInterests[profileInterest.id]}
                onSelect={() =>
                  handleProfileInterestsSelect(profileInterest.id)
                }
                key={profileInterest.id}
                disable={
                  selectedProfileInterestsCount === maxLimit &&
                  !selectedProfileInterests[profileInterest.id]
                }
              >
                {profileInterest?.Transalations?.name ||
                  profileInterest.description}
              </CustomSelector>
            );
          })}
        </div>
      </div>
      <div className={styles.wrapper}>
        <div className={styles["buttons-container"]}>
          <CustomButton
            onClick={handleSave}
            loading={saveLoading || imageLoading}
            color="primary"
          >
            {t("save")}
          </CustomButton>
        </div>
      </div>
    </div>
  );
}
